import { Container } from 'components/atoms';
import { FormInput } from 'components/molecules';
import DataWrapper from 'components/molecules/data-wrapper/DataWrapper';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { PiWallet } from 'react-icons/pi';
import { ICashFlowForm } from 'services/cash-flow/types';
import { booleanSelectOptions } from 'utils/components/inputs/select';

const CashFlowData = () => {
  const { t } = useTranslation();
  const { values } = useFormikContext<ICashFlowForm>();
  return (
    <DataWrapper>
      <Container>
        <Container.Header
          title={
            <>
              <PiWallet /> {t('cash-flow.tabs.data')}
            </>
          }
        />
        <Container.Content className="w-full items-center">
          <FormInput.Number
            name="amountNet"
            label={t('input.label.net')}
            placeholder={`0 ${'PLN'}`}
            suffix={` ${'PLN'}`}
          />
          <FormInput.Number
            name="amountGross"
            label={t('input.label.gross')}
            placeholder={`0 ${'PLN'}`}
            suffix={` ${'PLN'}`}
          />
          <FormInput.Number name="tax" label={t('input.label.tax')} placeholder="0 %" suffix=" %" />
          <FormInput.Select
            name="settlementPeriodId"
            label={t('input.label.settlementPeriodId')}
            value={
              values.settlementPeriod
                ? {
                    value: values.settlementPeriodId,
                    label: `${values.settlementPeriod.name} ${values.settlementPeriod.year}`,
                  }
                : undefined
            }
            isAsync
          />
          {values.repaymentsFromAllContracts !== undefined && (
            <FormInput.Number
              name="remainingNetAmount"
              label={t('input.label.remainingNetAmount')}
              suffix={` PLN`}
            />
          )}
          {values.repaymentsFromAllContracts !== undefined && (
            <FormInput.Select
              options={booleanSelectOptions}
              label={t('input.label.repaymentsFromAllContracts')}
              name="repaymentsFromAllContracts"
            />
          )}
        </Container.Content>
      </Container>{' '}
    </DataWrapper>
  );
};

export default CashFlowData;
